export namespace RegexLib {
  export const ALLOWEDCHARREGEX = /^[a-zA-Z0-9\.\_\[\]\?\,\#\$\&\@\' ]+$/;

  export const ALLOWEDCHAR = "a-z A-Z 0-9  . _ [  ] ? , # $ & @ '";

  export const HTMLREGEX = /<\/?[^>]+(>|$)/g;

  export const PHONEREGEX = /^[\+0-9 ]+$/;

  export const MINPASSWORDLENGTH = 8;

  export const OTPLENGTH = 6;
  // export const SPECIALCHAR = /^[a-zA-Z0-9]+$/;
  export const SPECIALCHAR = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

  export const EMAILREGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  export const VALIDURLREGEX =
    '^(https?:\\/\\/)((([-a-z0-9]{1,63}\\.)*?[a-z0-9]([-a-z0-9]{0,253}[a-z0-9])?\\.[a-z]{2,63})|((\\d{1,3}\\.){3}\\d{1,3}))(:\\d{1,5})?((\\/|\\?)((%[0-9a-f]{2})|[-\\w\\+\\.\\?\\/@~#&=])*)?$';

  export const GOOGLE_DRIVE_REGEX =
    /^https?:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9-_]{33})\/view\?usp=(sharing)|(drive_link)$/

  export const EmailCharacterValidationRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  export const OnlyAllowedSpecialCharacters = '! " \' ( ) - . , / : ?';
  
  export const OnlyAllowedCharactersRegex = /^[!\"'()\-,./:?A-Za-z0-9\s]*$/;

  export const OnlyAllowedCharactersRegexFileUpload = /^[!\"'()\-_,./:?A-Za-z0-9\s]*$/;

  export const AskInsightsQuesRegex = /^[a-zA-Z0-9.,'"?$\&%\s-“”]+$/;
  
  export const OnlyAllowedSpecialCharactersAskInsights = '" \' - . , ? $ & %';

  export const TimeRegex = /^(1[0-2]|0?[1-9]):([0-5][0-9])\s(?:AM|PM)$/; // Regex for HH:MM a format
}
